<template>
  <v-layout wrap>
    <v-flex sm1>
      <p>{{ rango.rango }}</p>
    </v-flex>
    <v-flex sm1>
      <p>{{ rango.minRango }}</p>
    </v-flex>
    <v-flex sm1>
      <p>{{ rango.maxRango }}</p>
    </v-flex>
    <v-flex sm4>
      <p>{{ rango.diagnosis }}</p>
    </v-flex>
    <v-flex sm4>
      <p>{{ rango.recommendation }}</p>
    </v-flex>
    <v-flex sm1>
      <v-icon @click="dialog = true" class="mr-2">mdi-pencil-outline</v-icon>
      <v-icon @click="dialogDelete = true" class="mr-2">mdi-close</v-icon>
    </v-flex>

    <!-- Ventana para crear rango -->
    <v-dialog v-model="dialog" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Crear rango</v-card-title>

        <v-form ref="form" @submit.prevent="send">
          <v-container>
            <v-layout wrap>
              <v-flex sm12>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="rangoIndex"
                      label="Rango"
                      :rules="requiredRule"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-model="minRango"
                      label="Rango minímo"
                      :rules="requiredRule"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-model="maxRango"
                      label="Rango máximo"
                      :rules="requiredRule"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field v-model="diagnosis" label="Diagnóstico" :rules="requiredRule"></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-model="recommendation"
                      label="Recomendación"
                      :rules="requiredRule"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false">cancelar</v-btn>
            <v-btn color="primary" text type="submit">Actualizar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Ventana para eliminar -->
    <v-dialog v-model="dialogDelete" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Eliminar rango</v-card-title>

        <v-card-text class="title">¿Estás seguro de eliminar a este rango?</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogDelete = false">cancelar</v-btn>
          <v-btn color="primary" text @click="deleteRango">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" right top :timeout="3000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  props: {
    rango: Object
  },
  data() {
    return {
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      dialog: false,
      snackbar: false,
      message: "",
      dialogDelete: false,

      rangoIndex: this.rango.rango,
      minRango: this.rango.minRango,
      maxRango: this.rango.maxRango,
      diagnosis: this.rango.diagnosis,
      recommendation: this.rango.recommendation,

      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    send() {
      if (this.$refs.form.validate()) {
        let data = {
          idRango: this.rango.idRango,
          rango: this.rangoIndex,
          minRango: this.minRango,
          maxRango: this.maxRango,
          diagnosis: this.diagnosis,
          recommendation: this.recommendation,
          idUserVerify: sessionStorage.getItem("authorization")
        };

        axios
          .post(this.host + "/rango/update.php", this.createFormData(data))
          .then(response => {
            if (response.data.status) {
              this.dialog = false;
              this.message = response.data.message;
              this.snackbar = true;
              this.$emit("update");
              this.$refs.form.resetValidation();
            } else {
              this.snackbar = true;
              this.message = response.data.message;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    deleteRango() {
      let data = {
        idRango: this.rango.idRango,
        idUserVerify: sessionStorage.getItem("authorization")
      };
      axios
        .post(this.host + "/rango/delete.php", this.createFormData(data))
        .then(response => {
          if (response.data.status) {
            this.dialogDelete = false;
            this.message = response.data.message;
            this.snackbar = true;
            this.$emit("update");
          } else {
            this.snackbar = true;
            this.message = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  }
};
</script>